import { render, staticRenderFns } from "./orderEditDialog.vue?vue&type=template&id=2aee1716&scoped=true"
import script from "./orderEditDialog.vue?vue&type=script&lang=js"
export * from "./orderEditDialog.vue?vue&type=script&lang=js"
import style0 from "./orderEditDialog.vue?vue&type=style&index=0&id=2aee1716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aee1716",
  null
  
)

export default component.exports